import { useFormContext } from 'react-hook-form';

import StatusMessage from '../statusMessage';

export const FormRootError = () => {
  const form = useFormContext(); // This component must be used within a FormProvider
  if (!('formState' in form)) {
    throw new Error('FormRootError must be used within a FormProvider'); // This is a developer error. FormRootError must be used within a FormProvider
  }

  const { errors } = form.formState;
  if (errors.root?.types && 'title' in errors.root.types) {
    // Only show error, if it's a root error with a title
    const { title, message, details } = errors.root.types as {
      title: string;
      message: string;
      details: string;
    };
    return (
      <StatusMessage
        type="destructive"
        title={title}
        message={message}
        details={details}
      />
    );
  }
  return undefined;
};
